/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Checkbox,
  useToast,
  VStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@chakra-ui/react';

import { useState } from 'react';
import { useTheme } from '../../contexts/ThemeProvider';
import { Button } from '../../components/atoms/Button';
import { Text } from '../../components/atoms/Text';

export function TelemedicineAcceptModal({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const toast = useToast();

  const { name } = useTheme();
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [acceptedShareInformation, setAcceptedShareInformation] = useState(false);

  const handleClick = () => {
    if (!acceptedTerms || !acceptedShareInformation) {
      toast({
        title: 'Erro',
        description: 'Você precisa aceitar os termos de uso e compartilhamento de informações para continuar.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    localStorage.setItem('acceptedTerms', JSON.stringify(acceptedTerms));
    localStorage.setItem('acceptedShareInformation', JSON.stringify(acceptedShareInformation));

    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay />
        <ModalContent margin={4}>
          <ModalHeader>Termos de Uso - Telemedicina</ModalHeader>
          <ModalBody>
            <VStack spacing={5} alignItems={'start'}>
              <Text textAlign={'center'}>
                Bem-vindo ao serviço de telemedicina do {name}! Aqui você pode consultar médicos de diversas áreas e
                especialidades, sem sair de casa.
              </Text>

              <Text textAlign={'center'}>
                Antes de continuar, por favor, concorde com os termos de uso do serviço de telemedicina.
              </Text>

              <VStack spacing={2} alignItems={'start'}>
                <Checkbox
                  textDecoration={'underline'}
                  isChecked={acceptedTerms}
                  onChange={(e) => setAcceptedTerms(!!e.target.checked)}
                >
                  Eu concordo com os termos de uso
                </Checkbox>
                <Checkbox
                  textDecoration={'underline'}
                  isChecked={acceptedShareInformation}
                  onChange={(e) => setAcceptedShareInformation(!!e.target.checked)}
                >
                  Eu concordo com o compartilhamento das minhas informações pessoais, imagem e voz para fins de consulta
                  médica.
                </Checkbox>
              </VStack>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button onClick={handleClick} disabled={!acceptedTerms || !acceptedShareInformation}>
              Continuar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
